import { commentService } from '../_services';

const getDefaultState = () => {
  return {
    current: [],
    loading: {}
  }
}

export const comments = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        resetState ({ commit }) {
            commit('resetState')
        },
        getComments({ commit }, params) {
            commit('loadingRequest');
            return commentService.get(params)
                .then(
                    response => {
                        commit('getSuccess', response);
                    },
                    error => commit('callFailure', error)
                );
        },
        addComment({ commit }, params) {
            commit('loadingRequest');
            return commentService.add(params)
                .then(
                    response => {
                        commit('addSuccess', response);
                    },
                    error => commit('callFailure', error)
                )
        },
        editComment({ commit }, params) {
            commit('loadingRequest');
            return commentService.edit(params)
                .then(
                    response => {
                        commit('addSuccess', response);
                    },
                    error => commit('callFailure', error)
                )
        },
        removeComment({ commit }, id) {
            commit('loadingRequest');
            return commentService.remove(id)
                .then(
                    commit('removeSuccess'),
                    error => commit('callFailure', error)
                )
        }
    },
    mutations: {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        loadingRequest(state) {
            state.loading = true;
        },
        callFailure(state, error) {
            state.current = { error };
            state.loading = false;
        },
        getSuccess(state, response) {
            state.current = Object.values(response);;
            state.loading = false;
        },
        addSuccess(state, response) {
            state.loading = false;
        },
        removeSuccess(state) {
            //state.current = {};
            state.loading = false;
        },
    }
}